module.exports = __webpack_public_path__ + "static/media/dsideLogo.dda14757.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DynamicContent/About/dsideLogo.svg
// module id = 63
// module chunks = 0